import React from 'react';
import PropTypes from 'prop-types';
import { DIRECTIONS } from 'utils/constants';

function UpDirectionSVG() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path fill="none" d="M0 0h24v24H0V0z" />
      <path d="M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z" />
    </svg>
  );
}
function DownDirectionSVG() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path fill="none" d="M0 0h24v24H0V0z" />
      <path d="M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z" />
    </svg>

  );
}

function Direction({ disabled, direction, id, onClickHandler }) {
  return (
    <button
      className="btn btn-outline-secondary btn-sm m-0 mr-1 p-0"
      style={{ opacity: disabled ? '.35' : '1', cursor: disabled ? 'not-allowed' : 'pointer' }}
      id={id}
      type="button"
      onClick={onClickHandler}
      disabled={disabled}
    >
      {direction === DIRECTIONS.UP ? <UpDirectionSVG /> : <DownDirectionSVG />}
    </button>
  );
}

Direction.propTypes = {
  direction: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  onClickHandler: PropTypes.func.isRequired,
};

export default Direction;
